import styled from "styled-components";

export const Container = styled.div`
  .header {
    color: ${props => props.theme.textLight};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    h1 {
      font-family: ${props => props.theme.p1m.ff};
      font-size: ${({ theme }) => theme.h1.fs};
      color: ${({ theme }) => theme.textLight};
      line-height: 40px;
    }

    .link {
      text-decoration: none;
    }

    .highlight {
      margin-right: 12px;
      font-family: ${props => props.theme.p1m.ff};
      font-size: ${props => props.theme.p2r.fs};
      cursor: pointer;
    }
  }

  @media (max-width: 700px) {
    .header {
      h1 {
        font-size: 24px;
      }
    }
  }
`;
